export const NAVIGATION_RESPONSABLE_OFA: any[] = [
  {
    heading: true,
    title: 'OFA'
  },
  {
    'title': 'MES OFA',
    'url': '/mes-ofa',
    'icon': 'ft-book',
    'service': 'ofa',
    'childrens': [
      {
        'title': 'Mes propositions',
        'url': '/propositions',
        'service': 'ofa'
      },
      {
        'title': 'Recap soldes',
        'url': '/recap-solde',
        'service': 'ofa'
      },
    ]
  },
  {
    'heading': true,
    'title': 'DATABOOK'
  },
  {
    'title': 'Moi',
    'url': '/mon-databook',
    'icon': 'ft-book',
    'service': 'ofa',
    'childrens': [
      {
        'title': 'Mon DataBook',
        'url': '/moi',
        'service': 'ofa'
      },
      {
        'title': 'Mes historiques ofa',
        'url': '/mes-historiques-ofa',
        'service': 'ofa'
      },
      {
        'title': 'Mes historiques hors ofa',
        'url': '/mes-historiques-horsofa',
        'service': 'ofa'
      },
    ],
  },
  {
    'title': 'Mes collaborateurs',
    'url': '/mon-databook/collaborateurs',
    'service': 'ofa',
    'icon': 'ft-users'
  },

];

export const NAVIGATION_DIRECTEUR: any[] = [

  {

    'title': 'Tableau de bord',

    'icon': 'ft-home',

    'url': '/dashboard',

    'service': '*',

  },

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    'title': 'Ma structure',

    'url': '/structure',

    'icon': 'ft-database',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Campagne',

        'url': '/campagne-eia',

        'service': 'eia'

      },

      {

        'title': 'Affectations',

        'url': '/affectations-eia',

        'service': 'eia'

      },

      {

        'title': 'Agents',

        'url': '/agents-structure',

        'service': 'eia'

      }

    ]

  },

  {

    'title': 'MES EIA',

    'url': '/evaluation',

    'icon': 'ft-book',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'eia'

      },

      {

        'title': 'Agents N-1',

        'url': '/n-1',

        'service': 'eia'

      },

      {

        'title': 'Agents N-2',

        'url': '/n-2',

        'service': 'eia'

      },

      {

        title: 'Vue étendue',

        url: '/vue-etendue'

      },

      {
        title: 'Téléchargements',
        url: '/telechargement',
      },
      {
        title: 'Tableau de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          }
        ]
      }

    ]

  },
  {

    'title': 'Consultations',

    'url': '/consultation',

    'icon': 'ft-bookmark',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Mon brouillon',

        'url': '/brouillon',

        'service': 'eia'

      },

      {

        'title': 'Simulation',

        'url': '/simulation',

        'service': 'eia'

      },

    ]

  }
]

export const NAVIGATION_DIRECTEUR_HIERARCHIE: any[] = [

  {

    'title': 'Tableau de bord',

    'icon': 'ft-home',

    'url': '/dashboard',

    'service': '*',

  },

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    'title': 'Ma structure',

    'url': '/structure',

    'icon': 'ft-database',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Campagne',

        'url': '/campagne-eia',

        'service': 'eia'

      },
      {

        'title': 'Affectations',

        'url': '/affectations-eia',

        'service': 'eia'

      },

      {

        'title': 'Agents',

        'url': '/agents-structure',

        'service': 'eia'

      }

    ]

  },

  {

    'title': 'MES EIA',

    'url': '/evaluation',

    'icon': 'ft-book',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'eia'

      },

      {

        'title': 'Agents N-1',

        'url': '/n-1',

        'service': 'eia'

      },

      {

        'title': 'Agents N-2',

        'url': '/n-2',

        'service': 'eia'

      },

      {

        title: 'Vue étendue',

        url: '/vue-etendue'

      },
      {
        title: 'Téléchargements',
        url: '/telechargement',
      },
      {
        title: 'Tableaux de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          },
          {
            title: 'Contribution EIA',
            url: '/tb-contribution',
          }
        ]
      }
    ]

  },
  {

    'title': 'Consultations',

    'url': '/consultation',

    'icon': 'ft-bookmark',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Mon brouillon',

        'url': '/brouillon',

        'service': 'eia'

      },

      {

        'title': 'Simulation',

        'url': '/simulation',

        'service': 'eia'

      },

    ]

  }
]

export const NAVIGATION_DRHA: any[] = [

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    'title': 'Campagne',

    'url': '/campagne',

    'icon': 'ft-compass',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Initialisation',

        'url': '/initialisation-eia',

        'service': 'eia'

      },

      {

        'title': 'Suivi',

        'url': '/suivi-eia',

        'service': 'eia'

      },

    ]

  },

  {

    'title': 'MES EIA',

    'url': '/evaluation',

    'icon': 'ft-book',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'eia'

      },

      {

        'title': 'Agents N-1',

        'url': '/n-1',

        'service': 'eia'

      },

      {

        'title': 'Agents N-2',

        'url': '/n-2',

        'service': 'eia'

      },

      {

        title: 'Vue étendue',

        url: '/vue-etendue'

      },

      {
        title: 'Téléchargements',
        url: '/telechargement',
      },
      {
        title: 'Tableau de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          }
        ]
      }

    ]

  }
]

export const NAVIGATION_CONSEIL: any[] = [
]

export const NAVIGATION_PVCH: any[] = [

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    'title': 'Gestion des campagnes',

    'icon': 'ft-compass',

    'url': '/campagne',

    'childrens': [

      {

        'title': 'Initialisation',

        'icon': 'ft-compass',

        'url': '',

        'service': 'eia',

        'childrens': [

          {

            'title': 'Campagne',

            'url': '/initialisation-eia',

            'service': 'eia'

          },
          {

            'title': 'Compétences emplois',

            'url': '/competence-emploi',

            'service': 'eia'

          },

          {
            'title': 'Objectifs agents',
            'url': '/objectifs-agents',
            'service': 'eia'
          },

          {
            'title': 'Agents',
            'url': '/agents-eia',
            'service': 'eia'
          },

          {

            'title': 'Structures',

            'url': '/structures-eia',

            'service': 'eia'

          },

          {

            'title': 'Suivi évaluation',

            'url': '/suivi-eia',

            'service': 'eia'

          },

          {

            'title': 'Affectation hierarchie',

            'url': '/affectations-eia',

            'service': 'eia'

          },

          {

            'title': 'Agents mutés',

            'url': '/agent-mute',

            'service': 'eia'

          },

          {

            'title': 'Planifier entretien',

            'url': '/affectations-vue-etendue',

            'service': 'eia'

          },

        ]
      },
      {
        'title': 'Paramétrage Analyse',
        'url': '/reporting/appreciations-global',
      },
      {

        'title': 'Reporting',

        'icon': 'ft-clipboard',

        'url': '',

        'service': 'eia',

        'childrens': [
          {
            'title': 'Analyse triénnale',
            'url': '/reporting-analyse-trienale',
            'service': 'eia'
          },
          {
            'title': 'TB suivi évaluation',
            'url': '/tb-suivi-evaluation-admin',
            'service': 'eia'
          },
          {
            'title': 'TB resultat évaluation',
            'url': '/tb-resultat-evaluation-admin',
            'service': 'eia'
          },
          {

            'title': 'Agents Exceptionnels',

            'url': '/agent-exceptionnel',

            'service': 'eia'

          },
          {

            'title': 'Analyse EIA',

            'url': '/reporting-analyse-eia',

            'service': 'eia'

          },
          {

            'title': 'Taux execution',

            'url': '/reporting/taux-execution',

            'service': 'eia'

          },

          {

            'title': 'Delai execution',

            'url': '/reporting/delai-execution',

            'service': 'eia'

          },

          {

            'title': 'Perfomances structures',

            'url': '/reporting/performance-structure',

            'service': 'eia'

          },


          {

            'title': 'Performances agents',

            'url': '/reporting/performance-agent',

            'service': 'eia'

          },

          {

            'title': 'Compétences agents',

            'url': '/exportation-data',

            'service': '*'

          },

          {

            'title': 'Top 10/Flop 10',

            'url': '/reporting/top-ten-flop',

            'service': 'eia'

          },

          {

            'title': 'Formations',

            'url': '/reporting/formations',

            'service': 'eia'

          }

        ]

      },

      {

        'title': 'Extractions',

        'icon': 'ft-export',

        'url': '',

        'service': 'eia',

        'childrens': [

          {

            'title': 'Compétences',

            'url': '/extraction/competences',

            'service': 'eia'

          },

          {

            'title': 'Formations',

            'url': '/extraction/formations',

            'service': 'eia'

          },

          {

            'title': 'Analyses',

            'url': '/extraction/analyses-eia',

            'service': 'eia'

          },

        ]

      },

      {

        'title': 'Synthèse EIA',

        'icon': 'ft-export',

        'url': '',

        'service': 'eia',

        'childrens': [

          {

            'title': 'Objectif EIA',

            'url': '/synthese-eia/objectif-eia',

            'service': 'eia'

          },

          {

            'title': 'Savoir être',

            'url': '/synthese-eia/savoir-etre',

            'service': 'eia'

          },

          {

            'title': 'Savoir faire',

            'url': '/synthese-eia/savoir-faire',

            'service': 'eia'

          },

          {

            'title': 'Appréciation globale',

            'url': '/synthese-eia/appreciation-globale',

            'service': 'eia'

          },

          {

            'title': 'Réalisation',

            'url': '/synthese-eia/realisation',

            'service': 'eia'

          }

        ]

      },

      {

        'title': 'Historique',

        'icon': 'ft-archive',

        'url': '',

        'service': 'eia',

        'childrens': [

          {

            'title': 'Agents',

            'url': '/historique-eia',

            'service': 'eia'

          },

        ]

      },
      {
        title: 'Téléchargements',
        url: '/telechargement',
      },
    ]
  }
]

export const NAVIGATION_SUPER: any[] = [
  {
    title: 'Gestion des formations',
    url: '/gestion-reportings',
    icon: 'ft-archive ',
    childrens: [
      {
        'title': 'Catalogue formation',
        'url': '/catalogue-formation',
        'service': 'eia'
      },
      {
        'title': 'Formations',
        'url': '/formation-agent',
        'service': 'eia'
      },
      {
        'title': 'Historiques formations',
        'url': '/report-formation',
        'service': 'eia'
      }
    ]
  }
]

export const NAVIGATION_SUPER_ADMIN: any[] = [

  {

    'title': 'Tableau de bord',

    'icon': 'ft-home',

    'url': '/dashboard',

    'service': '*',

  },
  {

    'heading': true,

    'title': 'EIA'

  },

  {

    'title': 'Ma structure',

    'url': '/structure',

    'icon': 'ft-database',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Campagne',

        'url': '/campagne-eia',

        'service': 'eia'

      },

      {

        'title': 'Organisation',

        'url': '/organisation-eia',

        'service': 'eia'

      },

      {

        'title': 'Affectations',

        'url': '/affectations-eia',

        'service': 'eia'

      }

    ]

  },
  {

    'title': 'MES EIA',

    'url': '/evaluation',

    'icon': 'ft-book',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'eia'

      },

      {

        'title': 'Agents N-1',

        'url': '/n-1',

        'service': 'eia'

      },

      {

        'title': 'Agents N-2',

        'url': '/n-2',

        'service': 'eia'

      },

      {

        title: 'Vue étendue',

        url: '/vue-etendue'

      },

      {
        title: 'Téléchargements',
        url: '/telechargement',
      },
      {
        title: 'Tableau de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          }
        ]
      }
    ]

  },

  {

    'title': 'Campagne EIA',

    'url': '/campagne',

    'icon': 'ft-compass',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Initialisation',

        'url': '/initialisation-eia',

        'service': 'eia'

      },

      {

        'title': 'Suivi',

        'url': '/suivi-eia',

        'service': 'eia'

      },

      {

        'title': 'Reporting',

        'url': '/reporting-eia',

        'service': 'eia'

      }

    ]

  },

  {

    'title': 'Consultations',

    'url': '/consultation',

    'icon': 'ft-bookmark',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Mon brouillon',

        'url': '/brouillon',

        'service': 'eia'

      },

      {

        'title': 'Simulation',

        'url': '/simulation',

        'service': 'eia'

      },

    ]

  },

  {

    'heading': true,

    'title': 'Administration'

  },

  {

    'title': 'Paramètres',

    'url': '/settings',

    'icon': 'ft-settings',

    'service': '*',

    'childrens': [

      {

        'title': 'Administrateurs',

        'url': '/utilisateurs/creation'

      },

      {

        'title': 'Utilisateurs',

        'url': '/agents'

      },

      {

        'title': 'Profil',

        'url': '/utilisateurs/profil'

      },

      {

        'title': 'Log',

        'url': '/log'

      }

    ]

  }

]

export const NAVIGATION_SUPER_ADMIN_HIERARCHIE: any[] = [

  {

    'title': 'Tableau de bord',

    'icon': 'ft-home',

    'url': '/dashboard',

    'service': '*',

  },

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    'title': 'Ma structure',

    'url': '/structure',

    'icon': 'ft-database',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Campagne',

        'url': '/campagne-eia',

        'service': 'eia'

      },

      {

        'title': 'Organisation',

        'url': '/organisation-eia',

        'service': 'eia'

      },

      {

        'title': 'Affectations',

        'url': '/affectations-eia',

        'service': 'eia'

      }

    ]

  },

  {

    'title': 'MES EIA',

    'url': '/evaluation',

    'icon': 'ft-book',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'eia'

      },

      {

        'title': 'Agents N-1',

        'url': '/n-1',

        'service': 'eia'

      },

      {

        'title': 'Agents N-2',

        'url': '/n-2',

        'service': 'eia'

      },

      {

        title: 'Vue étendue',

        url: '/vue-etendue'

      },
      {
        title: 'Téléchargements',
        url: '/telechargement',
      },
      {
        title: 'Tableau de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          }
        ]
      }

    ]

  },
  {

    'title': 'Campagne EIA',

    'url': '/campagne',

    'icon': 'ft-compass',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Initialisation',

        'url': '/initialisation-eia',

        'service': 'eia'

      },

      {

        'title': 'Suivi',

        'url': '/suivi-eia',

        'service': 'eia'

      },

      {

        'title': 'Reporting',

        'url': '/reporting-eia',

        'service': 'eia'

      }

    ]

  },

  {

    'title': 'Consultations',

    'url': '/consultation',

    'icon': 'ft-bookmark',

    'service': 'eia',

    'childrens': [

      {

        'title': 'Mon brouillon',

        'url': '/brouillon',

        'service': 'eia'

      },

      {

        'title': 'Simulation',

        'url': '/simulation',

        'service': 'eia'

      },

    ]

  },

  {

    'heading': true,

    'title': 'Administration'

  },

  {

    'title': 'Paramètres',

    'url': '/settings',

    'icon': 'ft-settings',

    'service': '*',

    'childrens': [

      {

        'title': 'Administrateurs',

        'url': '/utilisateurs/creation'

      },

      {

        'title': 'Utilisateurs',

        'url': '/agents'

      },

      {

        'title': 'Profil',

        'url': '/utilisateurs/profil'

      },

      {

        'title': 'Log',

        'url': '/log'

      }

    ]

  }

]

export const NAVIGATION_ADMIN: any[] = [
  {
    heading: true,
    title: 'Administration'
  },
  {
    title: 'Paramètres',
    url: '/settings',
    icon: 'ft-settings',
    childrens: [
      {
        title: 'Administrateurs',
        url: '/utilisateurs/creation'
      },
      {
        title: 'Utilisateurs',
        url: '/agents'
      },
      {
        title: 'Profil',
        url: '/utilisateurs/profil'
      }
    ]
  },
];
